<template>
    <div class="tp-data-form">
        <div class="h-panel-bar">
            <span class="h-panel-title">{{entity && entity.id ? '编辑' : '新增'}}{{(definition.name || '')}}数据</span>
        </div>
        <div class="h-panel-body">
            <Form :label-width="110" mode="block">
                <FormItem v-for="f in fields" :key="f.fieldName" :label="f.displayName" :required="f.required">
                    <NumberInput v-if="f.fieldType === 'NUMBER'" v-model="dataValue[f.fieldName]"/>
                    <DatePicker v-else-if="f.fieldType === 'DATE'" v-model="dataValue[f.fieldName]" format="YYYY-MM-DD"/>
                    <Input v-else v-model="dataValue[f.fieldName]"/>
                </FormItem>
                <FormItem label="附件数量">
                    <NumberInput v-model="receiptNum" :min="0"/>
                </FormItem>
                <FormItem label="备注">
                    <Textarea v-model="remark" :rows="2"/>
                </FormItem>
            </Form>
        </div>
        <div class="h-panel-bar text-right">
            <Button @click="$emit('close')">取消</Button>
            <Button color="primary" @click="save">保存</Button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TripartiteDataForm",
        props: {
            definition: Object,
            entity: Object
        },
        data() {
            return {
                dataValue: {},
                receiptNum: 0,
                remark: ''
            };
        },
        computed: {
            fields() {
                return (this.definition && this.definition.dataFields) || [];
            }
        },
        methods: {
            init() {
                let dv = {};
                this.fields.forEach(f => {
                    dv[f.fieldName] = null;
                });
                if (this.entity) {
                    Object.assign(dv, this.entity.dataValue || {});
                    this.receiptNum = this.entity.receiptNum || 0;
                    this.remark = this.entity.remark || '';
                } else {
                    this.receiptNum = 0;
                    this.remark = '';
                }
                this.dataValue = dv;
            },
            save() {
                for (let f of this.fields) {
                    if (f.required) {
                        let v = this.dataValue[f.fieldName];
                        if (v === null || v === undefined || String(v).trim() === '') {
                            this.$Message(`${f.displayName} 为必填项`);
                            return;
                        }
                    }
                }
                let p = {
                    id: this.entity ? this.entity.id : null,
                    dataValue: this.dataValue,
                    receiptNum: this.receiptNum,
                    remark: this.remark
                };
                let req = (this.entity && this.entity.id)
                    ? this.$api.tripartite.data.update(this.definition.id, p)
                    : this.$api.tripartite.data.save(this.definition.id, p);
                req.then(() => {
                    this.$Message('保存成功');
                    this.$emit('success');
                });
            }
        },
        watch: {
            entity() {
                this.init();
            }
        },
        mounted() {
            this.init();
        }
    };
</script>

<style lang="less" scoped>
    .tp-data-form {
        display: flex;
        flex-direction: column;
        height: 100%;

        .h-panel-body {
            flex: 1;
            overflow: auto;
        }
    }
</style>
